import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  ChevronDown,
  Clock,
  LucideIconData,
  Mail,
  MapPin,
  MessageCircle,
  Phone,
} from 'lucide-angular';

import { AosDirective } from '../../shared/directives/aos.directive';
import { IconComponent } from '../../shared/ui';
import { SeoService } from '../../shared/services/seo.service';
import { absoluteUrl } from '../../shared/utils/seo.utils';
import { SEO_DEFAULTS } from '../../shared/constants/seo.constants';
import { MOCK_CONTACT } from './data/mock-contact';

@Component({
  selector: 'app-contact-page',
  imports: [IconComponent, AosDirective],
  templateUrl: './contact-page.component.html',
  styleUrl: './contact-page.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class ContactPageComponent implements OnInit {
  protected readonly data = MOCK_CONTACT;
  protected readonly mascotError = signal(false);

  private sanitizer = inject(DomSanitizer);
  private readonly seoService = inject(SeoService);

  protected readonly mapEmbedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
    'https://www.google.com/maps?q=Plaza+Del+Castillo+Zapote+San+Jose+Costa+Rica&output=embed',
  );

  ngOnInit(): void {
    // El resolver ya aplicó title/description/canonical estáticos. Aquí
    // sobreescribimos `jsonLd` con LocalBusiness para enriquecer SEO local
    // (Google Maps, Knowledge Graph) sin duplicar metadatos.
    this.seoService.apply({
      title: 'Contacto',
      description:
        'Escríbenos por WhatsApp, correo o visítanos en Plaza Del Castillo, Zapote, San José. Atención al cliente Perrón Store.',
      canonical: '/contacto',
      jsonLd: {
        '@context': 'https://schema.org',
        '@type': 'LocalBusiness',
        name: SEO_DEFAULTS.siteName,
        description:
          'Tienda especializada en Trading Card Games (TCG) en Costa Rica.',
        image: absoluteUrl('/images/logo/logo.png'),
        url: SEO_DEFAULTS.siteUrl,
        telephone: this.data.channels.phone.value,
        email: this.data.channels.email.value,
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'Plaza Del Castillo Local #17',
          addressLocality: 'Zapote, San José',
          addressRegion: 'San José',
          addressCountry: 'CR',
        },
        openingHours: 'Tu-Su 12:00-19:00',
        sameAs: [SEO_DEFAULTS.social.instagram, SEO_DEFAULTS.social.facebook],
      },
    });
  }

  protected onMascotError(): void {
    this.mascotError.set(true);
  }

  protected readonly whatsappIcon: LucideIconData = MessageCircle;
  protected readonly mailIcon: LucideIconData = Mail;
  protected readonly phoneIcon: LucideIconData = Phone;
  protected readonly mapPinIcon: LucideIconData = MapPin;
  protected readonly clockIcon: LucideIconData = Clock;
  protected readonly chevronDownIcon: LucideIconData = ChevronDown;
}
